var React = require('react');

function UpArrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#383838;}\n"),React.createElement("path",{"className":"st0","d":"M7.8,21c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.6-0.1C6.2,21,6.2,21,6.2,21V4.4L0.3,8.9L0.2,9\n\tC0.1,9,0.1,8.9,0,8.8c0-0.1,0-0.1,0-0.2L6.7,0c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1l6.7,8.6l0,0.1c0,0,0,0.1-0.1,0.1\n\tc-0.1,0.1-0.1,0.1-0.1,0.1L7.8,4.4V21z","key":1})]);
}

UpArrow.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 13.9 21.1","style":{"enableBackground":"new 0 0 13.9 21.1"},"xmlSpace":"preserve"};

module.exports = UpArrow;

UpArrow.default = UpArrow;
